export interface ArtifactCardNeighbors {
	readonly hasTextBefore: boolean;
	readonly hasTextAfter: boolean;
}

export function getArtifactCardNeighbors(
	messageContent: string,
	artifactId: string,
): ArtifactCardNeighbors {
	const escapedId = artifactId.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	const tagRegex = new RegExp(
		`<object\\s+id=["']${escapedId}["'][^>]*>(?:[\\s\\S]*?<\\/object>)?`,
		"i",
	);
	const match = tagRegex.exec(messageContent);

	if (!match) {
		return { hasTextBefore: false, hasTextAfter: false };
	}

	const stripOtherArtifacts = /<object[^>]*>(?:[\s\S]*?<\/object>)?/gi;
	const before = messageContent.slice(0, match.index).replace(stripOtherArtifacts, "").trim();
	const after = messageContent
		.slice(match.index + match[0].length)
		.replace(stripOtherArtifacts, "")
		.trim();

	return { hasTextBefore: before.length > 0, hasTextAfter: after.length > 0 };
}
